import { type GroupBase, type StylesConfig } from 'react-select';
import { type ReactSelectOption } from './index';

const reactSelectStyles: StylesConfig<ReactSelectOption, true, GroupBase<ReactSelectOption>> = {
  control: (base) => ({
    ...base,
    backgroundColor: 'var(--component--input-background-primary)',
    minHeight: 48,
    borderRadius: 0,
    border: 0,
    borderBottom:
      'calc(var(--component--input-border-width-bottom) * 1px) solid var(--component--input-border-default)',
    paddingLeft: 6,
  }),
  input: (base) => ({
    ...base,
    color: 'var(--component--input-text-value-default)',
  }),
  option: (base, state) => ({
    ...base,
    'color': 'var(--component-dropdown-text-item-default)',
    'paddingTop': 16,
    'paddingBottom': 16,
    'paddingLeft': 16,
    'backgroundColor': state.isFocused
      ? 'var(--component-dropdown-background-item-hover)'
      : 'var(--component-dropdown-background-item-default)',
    'borderBottom': '1px solid var(--component-dropdown-border-item-divider-default)',
    ':active': {
      backgroundColor: 'var(--component-dropdown-background-item-selected-default)',
    },
  }),
  menu: (base) => ({
    ...base,
    marginTop: 0,
    backgroundColor: 'var(--component-dropdown-background-primary)',
  }),
  menuList: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    backgroundColor: 'var(--component-dropdown-background-primary)',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#353535ff',
    color: 'white',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'white',
  }),
  multiValueRemove: (base) => ({
    ...base,
    'color': 'white',
    'backgroundColor': '#5a5a5aff',
    ':hover': {
      backgroundColor: '#777777ff',
    },
  }),
};

export default reactSelectStyles;
